/** Keep replay event timing alive when an optional visual fails to load. */
export function createCombatAnimation(
  scene: Phaser.Scene, key: string, texture: string, start: number, eventFrames: number[] = [], repeat = 0
) {
  const existing = scene.anims.get(key);
  const available = scene.textures.exists(texture);
  if (existing?.frames.length && !(existing.frames[0].textureKey === 'custom-blank' && available)) return;
  if (existing) scene.anims.remove(key);

  let frames = available
    ? scene.anims.generateFrameNames(texture, { start, end: scene.textures.get(texture).frameTotal - 1 })
    : [];
  if (!frames.length) {
    console.warn('Combat visual unavailable; preserving turn events:', key, texture);
    // Transparent frames still emit updates, so damage/buffs happen once at their normal frame.
    frames = Array.from({ length: Math.max(2, ...eventFrames) + 1 }, () => ({ key: 'custom-blank', frame: '__BASE' }));
  }
  scene.anims.create({ key, frameRate: 12, frames, repeat });
}
